import _ from 'lodash';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

export const SYSTEM_ADMIN_ROLE = 'super';
export const ADMIN_ROLE = 'admin';
export const USER_ROLE = 'user';
export const ADMIN_ROLES = [SYSTEM_ADMIN_ROLE, ADMIN_ROLE];
export const ROLE_NAMES = {
    [USER_ROLE]: i18n._(t`User`),
    [ADMIN_ROLE]: i18n._(t`Admin`),
    [SYSTEM_ADMIN_ROLE]: i18n._(t`System Admin`),
};
export const ALL_ROLES_KEY_VALUE = {
    [USER_ROLE]: ROLE_NAMES[USER_ROLE],
    [ADMIN_ROLE]: ROLE_NAMES[ADMIN_ROLE],
    [SYSTEM_ADMIN_ROLE]: ROLE_NAMES[SYSTEM_ADMIN_ROLE],
};
export const ADMIN_ONLY_ROLES_KEY_VALUE = _.omit(ALL_ROLES_KEY_VALUE, [SYSTEM_ADMIN_ROLE]);

export const USER_DETAIL_NOT_ALLOWED_KEY = 'user_detail_not_allowed';
export const CANNOT_DELETE_SELF_KEY = 'cannot_delete_self';
export const CANNOT_DELETE_DEFAULT_KEY = 'cannot_delete_default';
export const ADMIN_USER_CANNOT_DELETE_OTHER_ADMIN_KEY = 'admin_user_cannot_delete_other_admin';

export const USER_SOURCE_LDAP = 'ldap';
export const USER_SOURCE_SAML = 'saml';
export const USER_SOURCE_LOCAL_CAC = 'cac_local';
export const USER_SOURCE_LDAP_CAC = 'cac_ldap';
export const USER_SOURCE_NG1 = 'ngeniusone';
export const USER_SOURCE_NGP = 'local';
export const USER_SOURCE_NGP_DEFAULT = 'default';

export const USER_SOURCE_FIELD = 'source';
export const USER_ROLE_FIELD = 'userRole';
export const USER_STATUS_FIELD = 'userStatus';
export const FULL_NAME_FIELD = 'fullName';
export const FIRST_NAME_FIELD = 'firstName';
export const LAST_NAME_FIELD = 'lastName';
export const TIME_ZONE_FIELD = 'timeZone';
export const EMAIL_FIELD = 'email';
export const GROUPS_FIELD = 'groups';
export const USER_NAME_FIELD = 'userName';
export const PASSWORD_FIELD = 'password';
export const CONFIRM_PASSWORD_FIELD = 'confirmPassword';
export const DARK_MODE_FIELD = 'darkMode';
export const MERIDIEM_TIME_FIELD = 'meridiemTimeFormat';
export const LOCKED_OUT_UNTIL_FIELD = 'lockedOutUntil';
export const SOURCE = 'source';
export const NOTIFICATIONS_FIELD = 'notifications';
export const AGENT_HEARTBEAT_FIELD = 'agentHeartbeat';
export const AGENT_HEARTBEAT_NOTIFICATIONS_FIELD = `${NOTIFICATIONS_FIELD}.${AGENT_HEARTBEAT_FIELD}`;
export const USER_EMAIL_ADDRESSES_FIELD = 'userEmailAddresses';

export const DETAIL_PASSWORD = 'mdlChangeMe1';

export const USER_STATUS_ENABLED_OPTION = 'ENABLED';
export const USER_STATUS_DISABLED_OPTION = 'DISABLED';
export const USER_STATUS_INVITED_OPTION = 'INVITED';

export const USER_STATUS_ENABLED_TEXT = 'Enabled';
export const USER_STATUS_DISABLED_TEXT = 'Disabled';
export const USER_STATUS_INVITED_TEXT = 'Invited';

export const USER_DETAIL_STATUS_OPTIONS = {
    ENABLED: USER_STATUS_ENABLED_TEXT,
    DISABLED: USER_STATUS_DISABLED_TEXT,
};

export const USER_STATUS_NAMES = {
    [USER_STATUS_ENABLED_OPTION]: USER_STATUS_ENABLED_TEXT,
    [USER_STATUS_DISABLED_OPTION]: USER_STATUS_DISABLED_TEXT,
    [USER_STATUS_INVITED_OPTION]: USER_STATUS_INVITED_TEXT,
};

export const ACCESS_RULES = 'access.rights';
export const USER_ACCESS_ENTITY = 'entity';
export const USER_ACCESS_PLM_NAME = 'name';
export const USER_ACCESS_PLM_DESCRIPTION = 'description';
export const USER_ACCESS_PLM_ID = 'id';
export const USER_ACCESS_PLM_EDITABLE = 'editable';

export const NG1_PRIVILEGE_UNIVERSAL_MONITOR = 'UNVRLMON';
